import React from 'react';
import {useRouteMatch} from 'react-router-dom';
import DataTableWithFilters from './components/DataTableWithFilters';
import ButtonSelectRow from '../ButtonSelectRow';
import saveIcon from 'common/assets/add-button.svg';
import {pathnames as P} from 'common/constants/pathnames';
import {messages as M} from '../../constants/messages';
import {convertBinaryToString} from '../../../../common/utils/form/convertBinaryToString';
import {getSalePricePart} from '../../../../common/utils/form/getSalePricePart';
import dayjs from "dayjs";

const TabTaxAuthority = ({
                           getStep9GridTaxAuthority,
                           setStep9TaxAuthorityPage,
                           getStep9GridTaxAuthorityForExcel,
                           getStep9SavedRows,
                           saveRow,
                           removeRow,
                           list,
                           page,
                           totalPages,
                           totalResultCount,
                           showLittlePopup,
                           saveFilters,
                           previousFilters,
                           ...rest
                         }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);

  const preparedList = list && list.map(item => {
    const checkboxProps = {
      action: () => {
        saveRow({shumaId, ...item})
          .then((response) => {
            const message = response.data.errorCode === -1
              ? M.FAILED : M.GRID_ROW_SAVED;
            showLittlePopup(message)
          })
      },
      icon: saveIcon,
    };

    const {
      elevator, storage, lot, gallery, saleDate,
      netAreaInSquareMeters, roomCount, salePrice, soldShare,
      ...rest
    } = item;

    return {
      saleDate: saleDate ? dayjs(saleDate).format('DD-MM-YYYY') : '',
      elevator: convertBinaryToString(elevator),
      storage: convertBinaryToString(storage),
      lot: convertBinaryToString(lot),
      gallery: convertBinaryToString(gallery),
      ...rest,
      checked: <ButtonSelectRow {...checkboxProps}/>,
      netAreaInSquareMeters,
      roomCount,
      salePrice,
      soldShare,
      areaRooms: netAreaInSquareMeters && roomCount
        ? (netAreaInSquareMeters/roomCount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        : '',
      salePriceSoldShare: salePrice && soldShare
        ? (Number(salePrice.replace(/,/g, "")) * getSalePricePart(soldShare)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2})
        : ''
    };
  });

  return (
    <DataTableWithFilters
      shumaId={shumaId}
      getListHandler={getStep9GridTaxAuthority}
      getListForExcelHandler={getStep9GridTaxAuthorityForExcel}
      data={preparedList}
      page={page}
      setPage={setStep9TaxAuthorityPage}
      totalPages={totalPages}
      totalResults={totalResultCount}
      filtersPresistanceOptions={{
        saveFilter: saveFilters,
        previousFilters
      }}
      {...rest}
    />
  );
};

export default TabTaxAuthority;